import { Component, OnInit, Input } from '@angular/core';
import { UtilsService } from '@core/services';

@Component({
  selector: 'app-password-strength-bar',
  templateUrl: './password-strength-bar.component.html',
  styleUrls: ['./password-strength-bar.component.scss']
})
export class PasswordStrengthBarComponent implements OnInit {
  @Input() passwordToCheck: string;
  @Input() extraClasses: string;
  @Input() target: string;
  isMobile: boolean = false;

  ngOnInit(): void {
    this.isMobile = UtilsService.isMobile();
  }
}
